/**
 *
 * Asynchronously loads the component for Title
 *
 */

import React from 'react';
import { lazyLoad } from 'app/components/Loadable';
import { Loading } from './components/Loading';

export const App = lazyLoad(
  () => import('./index'),
  module => module.App,
  {
    fallback: <Loading />,
  },
);
